/**
 * An audit entry's actor in words: "Graham Whitlock", or (APP-122) when a tester acted as them in
 * Preview as, "Graham Whitlock (by Sam Tester in Preview as)", so every history names who was
 * really signed in.
 */
export function actorWords(name: string, previewedBy: string | null | undefined): string {
  return previewedBy == null ? name : `${name} (by ${previewedBy} in Preview as)`;
}
